<template>
  <div class="item-left">
    <div class="item-list" v-for="item in filesRead" :key="item.index">
      <div class="list-text" v-for="vtem in item.files" :key="vtem.index">
        <img src="../../../../public/icon/pdf.png" alt="" />
        <div class="list-name">
          <h3>
            {{ vtem.name }}
          </h3>
          <div class="list-desc">
            <p>上传时间：{{ item.createAt }}</p>
            <p>大小：{{ (vtem.size / 1024).toFixed(2) }} KB</p>
          </div>
        </div>
      </div>
      <div class="list-down">
        <h4>免费</h4>
        <el-button size="small" @click="hitDownload" round>点击下载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessageBox } from "element-plus";
export default {
  props: {
    filesRead: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const hitDownload = () => {
      try {
        ElMessageBox.alert(
          "<p>暂未开通在线下载、请添加客服老师微信领取</p><p>刘老师(微信):18019934025</p><p>徐老师(微信):13205515869</p><p>黄老师(微信):13075567156</p><p>刘校长(微信):18505513002</p>",
          "欢迎来到山河医学网",
          {
            dangerouslyUseHTMLString: true,
          }
        );
      } catch (error) {
        console.log(error);
      }
    };
    return { hitDownload };
  },
};
</script>

<style lang="less" scoped>
.item-left {
  //display: flex;
  //justify-content: space-between;
  //align-items: flex-start;
  //flex-wrap: wrap;
  width: 830px;
  border-radius: 8px;
  background: #fff;

  .item-list {
    display: flex;
    .list-text {
      display: flex;
      align-items: center;
      width: 630px;
      height: 130px;
      //background: #e2e1e1;
      img {
        width: 60px;
        height: 60px;
        margin-left: 25px;
        margin-right: 15px;
      }

      .list-name {
        .list-desc {
          display: flex;
          p {
            margin-top: 15px;
            margin-right: 30px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.6);
          }
        }
      }
    }
    .list-down {
      display: flex;
      align-items: center;
      width: 180px;
      height: 130px;
      //background: #747070;
      h4 {
        display: inline-block;
        margin-right: 20px;
        margin-left: 15px;
        color: @shColor;
      }
    }
  }
}
</style>
